import { Controller } from '@hotwired/stimulus'
import { Popover } from 'bootstrap'

export default class extends Controller {
  static values = { title: String, content: String, url: String }

  connect() {
    this.timeout = null
    this.popoverInstance = this.createPopover()
  }

  createPopover() {
    const contentBody = this.concatContent()

    return new Popover(this.element, {
      title: this.titleValue,
      content: contentBody,
      trigger: 'manual',
      html: true,
    })
  }

  show() {
    const instance = Popover.getInstance(this.element)
    instance.show()

    // attach a hover event to the popover element itself to prevent it from hiding when the users mouse leaves the trigger element
    this.popoverElement = document.querySelector('.popover')
    // prevent hide call if user hovers over the popover content
    this.popoverElement?.addEventListener('mouseenter', this.preventHide.bind(this))
    this.popoverElement?.addEventListener('mouseleave', this.hide.bind(this))
  }

  hide() {
    // delay hiding to give time for user to hover over the popover element
    this.timeout = setTimeout(() => {
      const instance = Popover.getInstance(this.element)
      instance.hide()
    }, 500)
  }

  preventHide() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }

  disconnect() {
    if (this.popoverInstance) {
      this.popoverInstance.dispose()
    }

    if (this.popoverElement) {
      this.popoverElement.removeEventListener('mouseenter', this.preventHide.bind(this))
      this.popoverElement.removeEventListener('mouseleave', this.hide.bind(this))
    }
  }

  concatContent() {
    const fullUrl = new URL(this.urlValue, document.location).toString()
    const tag = document.createElement('a')
    tag.href = fullUrl
    tag.text = this.contentValue

    return tag
  }
}
